import {query} from "@solidjs/router";
import api from "~/api/api";
import {TagResponse, TagCreateRequest} from "@tag-tails/types";

// Gets a tag by its id.
export const getTag = query(async (id: string): Promise<TagResponse | null> => {
    "use server"
    try {
        const res = await api.get<TagResponse>(`/tags/${id}`);
        return res.data;
    } catch (e) {
        return null;
    }
}, "tagById");

// Retrieves all tags.
export const getTags = query(async (): Promise<TagResponse[] | null> => {
    "use server"
    try {
        const res = await api.get<TagResponse[]>(`/tags`);
        return res.data;
    } catch (e) {
        return null;
    }
}, "allTags");

// Retrieves tags filtered by user id.
export const getTagsByUser = query(async (userID: string): Promise<TagResponse[] | null> => {
    "use server"
    try {
        const res = await api.get<TagResponse[]>(`/tags?user=${userID}`);
        return res.data;
    } catch (e) {
        return null;
    }
}, "tagsByUser");

// Creates a new tag.
export async function createTag(payload: TagCreateRequest): Promise<TagResponse | null> {
    "use server"
    try {
        const res = await api.post<TagResponse>(`/tags`, payload);
        return res.data;
    } catch (e) {
        return null;
    }
}

// Updates an existing tag by its id.
export async function updateTag(id: string, payload: TagCreateRequest): Promise<TagResponse | null> {
    "use server"
    try {
        const res = await api.put<TagResponse>(`/tags/${id}`, payload);
        return res.data;
    } catch (e) {
        return null;
    }
}

// Deletes a tag by its id.
export async function deleteTag(id: string): Promise<boolean> {
    "use server"
    try {
        await api.delete(`/tags/${id}`);
        return true;
    } catch (e) {
        return false;
    }
}
